module.exports = __webpack_public_path__ + "static/media/login-ribbon.bdb11835.svg";